import { styled } from 'shared/Houston';

export const errorStyles = (error: number, before?: boolean) => {
  if (!error) {
    return;
  }

  return `
    &:${before ? 'before' : 'after'} {
      content: '';
      position: absolute;
      background: rgba(255, 255, 255, .5);
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  `;
};
export const Item = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing.nano} ${theme.spacing.nano} 0`};
  margin-bottom: ${({ theme }) => theme.spacing.nano};
  border-radius: ${({ theme }) => theme.border.radius.xs};
  border: 1px solid ${({ theme }) => theme.neutralColor.high.dark};

  label {
    margin-right: 0;

    svg[data-testId='CheckBoxOutlineBlankIcon'],
    svg[data-testId='RadioButtonUncheckedIcon'] {
      fill: ${({ theme }) => theme.neutralColor.low.medium};
    }

    & span[aria-disabled='true']:first-child svg[data-testId='CheckBoxOutlineBlankIcon'] {
      fill: ${({ theme }) => theme.neutralColor.high.dark};
    }

    svg {
      width: 1.563rem;
      height: 1.563rem;
    }
  }
`;

export const MainProductItem = styled.div<{ error: number }>`
  display: flex;
  align-items: flex-start;
  width: ${({ theme }) => `calc(100% - ${theme.spacing.nano})`};
  position: relative;

  ${({ error }) => errorStyles(error)}
`;

export const ChildProductItem = styled.div<{ error: number }>`
  position: relative;
  ${({ error }) => errorStyles(error, true)}
`;

export const ChildrenItem = styled.div<{ multipleSelection: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

export const ContentLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
`;

export const InvisibleButtonInfiniteScroll = styled.button`
  background-color: transparent;
  border: transparent;
  &:hover {
    background-color: transparent;
    border: transparent;
  }
`;

export const CenterImageIcon = styled.div`
  margin-top: calc(70px / 2);
`;

export const CenterToggle = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const CenterLoader = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;
